import { SxProps, Theme } from '@rossum/ui/material';

export const sharedStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  py: 1,
  px: 2,
  cursor: 'pointer',
  borderLeft: '5px solid transparent',
  '&:hover': {
    backgroundColor: t => t.palette.action.hover,
  },
};
